import React from 'react';
import { Link } from 'react-router-dom';
import './index.scss';

const PROJECTS = [
    { path: '/detailtwo',   name: 'Reserve Cut',      type: 'Branding Design' },
    { path: '/detailthree', name: 'Bluelander',        type: 'Re-Branding'     },
    { path: '/detailfour',  name: 'Glo Pret',          type: 'Branding Design' },
    { path: '/detailfive',  name: 'FTK Beauty Group',  type: 'Re-Branding'     },
    { path: '/detailsix',   name: 'Laila',             type: 'Branding Design' },
    { path: '/detailseven', name: 'Revelwear',         type: 'Re-Branding'     },
    { path: '/detaileight', name: 'Exoclinic',         type: 'Branding Design' },
    { path: '/detailnine',  name: 'M2C1',              type: 'Re-Branding'     },
    { path: '/detailten',   name: 'ZOEY',              type: 'Branding Design' },
    { path: '/detailone',   name: 'Bart Street',       type: 'Re-Branding'     },
];

const ProjectNav = ({ current }) => {
    const idx = PROJECTS.findIndex(p => p.path === current);
    const prev = PROJECTS[(idx - 1 + PROJECTS.length) % PROJECTS.length];
    const next = PROJECTS[(idx + 1) % PROJECTS.length];

    return (
        <nav className="projectNav">
            <Link to={prev.path} className="projectNavItem projectNavPrev">
                <span className="projectNavArrow" aria-hidden="true">←</span>
                <span className="projectNavLabel">
                    <span className="projectNavType">{prev.type}</span>
                    <span className="projectNavName">{prev.name}</span>
                </span>
            </Link>

            <Link to="/projects" className="projectNavAll">
                All Projects
            </Link>

            <Link to={next.path} className="projectNavItem projectNavNext">
                <span className="projectNavLabel projectNavLabelRight">
                    <span className="projectNavType">{next.type}</span>
                    <span className="projectNavName">{next.name}</span>
                </span>
                <span className="projectNavArrow" aria-hidden="true">→</span>
            </Link>
        </nav>
    );
};

export default ProjectNav;
